var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "bread-crumb",
    { attrs: { "list-classes": "breadcrumb-links breadcrumb-dark" } },
    [
      _c("BreadCrumbItem", [
        _c(
          "li",
          { staticClass: "breadcrumb-item" },
          [
            _c("router-link", { attrs: { to: "/" } }, [
              _c("i", { staticClass: "fas fa-home" }),
            ]),
          ],
          1
        ),
      ]),
      _vm._l(_vm.$route.matched.slice(), function (route, index) {
        return _c(
          "BreadCrumbItem",
          {
            key: route.name,
            staticStyle: { display: "inline-block" },
            attrs: { active: index === _vm.$route.matched.length - 1 },
          },
          [
            index < _vm.$route.matched.length - 1
              ? _c("router-link", { attrs: { to: { name: route.name } } }, [
                  _vm._v("\n      " + _vm._s(route.name) + "\n    "),
                ])
              : _c("span", [_vm._v(_vm._s(route.name))]),
          ],
          1
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }